
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.655 12.06h.659l3.533 3.55a.88.88 0 010 1.241.88.88 0 01-1.242 0l-3.541-3.541v-.659l-.225-.233a5.417 5.417 0 01-4.45 1.233c-2.317-.391-4.167-2.325-4.45-4.658a5.42 5.42 0 016.058-6.058c2.333.283 4.267 2.133 4.658 4.45a5.417 5.417 0 01-1.233 4.45l.233.225zM4.564 8.31a3.745 3.745 0 003.75 3.75 3.745 3.745 0 003.75-3.75 3.745 3.745 0 00-3.75-3.75 3.745 3.745 0 00-3.75 3.75z","fill":"#9AA0B5"}})])
          )
        }
      }
    